import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ExternalUrls } from '../../externalUrls';

export interface TenantPlanCheckResult {
  canTakeAction: boolean;
  reason: string;
  callToAction: string;
  displayTitleIcon: boolean;
}

@Component({
  selector: 'app-tenant-plan-error-modal',
  templateUrl: './tenant-plan-error-modal.component.html',
  styleUrls: ['./tenant-plan-error-modal.component.scss'],
  standalone: false
})
export class TenantPlanErrorModalComponent {
  readonly externalUrls = ExternalUrls;

  constructor(
    public dialogRef: MatDialogRef<TenantPlanErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TenantPlanCheckResult
  ) {}

  static openDialog(
    dialog: MatDialog,
    reason: string,
    callToAction: string,
    displayTitleIcon: boolean
  ): MatDialogRef<TenantPlanErrorModalComponent> {
    return dialog.open(TenantPlanErrorModalComponent, {
      data: {
        reason,
        callToAction,
        displayTitleIcon
      },
      width: '450px',
      panelClass: 'plan-dialog',
      autoFocus: 'dialog'
    });
  }
}
